import React, { Component } from "react";
import Swal from "sweetalert2";
import { getRequestParams } from "../../src/helpers/globalfunctions.js";

export class ForgotPasswordComponent extends Component {
  static displayName = ForgotPasswordComponent.name;

  constructor(props) {
    super(props);

    this.state = {
      emailAddress: "",
      message: "",
      errors: {
        emailAddress: "",
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleValidation = () => {
    let formIsValid = true;
    try {
      let errors = this.state.errors;
      errors.emailAddress = "";
      this.setState({ message: "" });

      if (this.state.emailAddress === "") {
        formIsValid = false;
        errors.emailAddress = "Please enter username/email.";
      }

      this.setState({ errors: errors });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleValidation function",
        err,
      );
      formIsValid = false;
    }
    return formIsValid;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (this.handleValidation()) {
      var resetPasswordRequest = {};
      resetPasswordRequest.UserName = this.state.emailAddress;
      const requestParams = getRequestParams("POST", resetPasswordRequest);
      try {
        const response = await fetch(
          process.env.REACT_APP_API_BASE_URL +
            "authentication/forget-password-request",
          requestParams,
        );
        const data = await response.json();
        Swal.fire({
          icon: data.isSuccess ? "Error" : "error",
          title: data.isSuccess ? "Success" : "Oops...",
          text: data.message,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (data.isSuccess) {
            if (result.isConfirmed) {
              this.setState({ emailAddress: "" });
              window.location.href = "/";
            } else {
              this.setState({ isSubmited: false });
            }
          } else {
            this.setState({ isSubmited: false });
          }
        });
      } catch (err) {
        console.log(
          "Error in " + this.displayName + ".handleSubmit function",
          err,
        );
        this.setState({ isSubmited: false });
      }
    }
  };

  render() {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          backgroundImage: "url('../assets/img/banner_akasa_air.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(10,20,60,0.82) 0%, rgba(10,20,60,0.35) 55%, rgba(10,20,60,0.1) 100%)",
          }}
        ></div>

        {/* Centered content */}
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            zIndex: 2,
            padding: "2rem 1rem",
          }}
        >
          <div style={{ width: "100%", maxWidth: 440 }}>
            {/* Card with colored header */}
            <div
              style={{
                borderRadius: 16,
                overflow: "hidden",
                boxShadow: "0 24px 64px rgba(0,0,0,0.45)",
              }}
            >
              {/* Gradient header */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
                  padding: "2.5rem 2rem 2rem",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                <img
                  src="https://akasa.utwiz.com/assets/img/logo_akasa_air.png"
                  alt="Akasa Air"
                  style={{
                    width: 130,
                    marginBottom: "1.75rem",
                  }}
                />
                <div
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 1rem",
                    fontSize: "1.6rem",
                  }}
                >
                  <i className="fas fa-lock"></i>
                </div>
                <h4
                  style={{
                    fontWeight: 700,
                    marginBottom: "0.4rem",
                    fontSize: "1.3rem",
                  }}
                >
                  Forgot Password?
                </h4>
                <p
                  style={{
                    fontSize: "0.85rem",
                    opacity: 0.72,
                    marginBottom: 0,
                  }}
                >
                  Enter your details and we'll send you a reset link.
                </p>
              </div>

              {/* White form body */}
              <div style={{ background: "#fff", padding: "2rem" }}>
                <form
                  method="post"
                  onSubmit={this.handleSubmit}
                  style={
                    this.state.isSubmited
                      ? { pointerEvents: "none", opacity: "0.4" }
                      : {}
                  }
                >
                  <div className="mb-4">
                    <label
                      htmlFor="emailAddress"
                      className="form-label fw-semibold"
                      style={{ fontSize: "0.85rem", color: "#495057" }}
                    >
                      Username / Email
                    </label>
                    <div className="input-group input-group-lg">
                      <span
                        className="input-group-text bg-light border-end-0 text-muted"
                        style={{ borderRadius: "10px 0 0 10px" }}
                      >
                        <i className="fas fa-envelope"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control bg-light border-start-0"
                        id="emailAddress"
                        name="emailAddress"
                        placeholder="Enter username or email"
                        value={this.state.emailAddress}
                        onChange={this.handleInputChange}
                        tabIndex="1"
                        autoFocus
                        style={{
                          borderRadius: "0 10px 10px 0",
                          fontSize: "0.95rem",
                        }}
                      />
                    </div>
                    {this.state.errors["emailAddress"].length > 0 && (
                      <span className="error-msg">
                        {this.state.errors["emailAddress"]}
                      </span>
                    )}
                  </div>

                  <div className="mb-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg w-100"
                      tabIndex="2"
                      style={{
                        borderRadius: "10px",
                        padding: "0.75rem",
                        fontSize: "1rem",
                        letterSpacing: "0.03em",
                      }}
                    >
                      <i className="fas fa-paper-plane me-2"></i> Send Reset
                      Link
                    </button>
                  </div>

                  <div
                    className="text-center pt-3"
                    style={{ borderTop: "1px solid #f0f2f5" }}
                  >
                    <a
                      href="/"
                      style={{
                        fontSize: "0.85rem",
                        color: "#6c757d",
                        textDecoration: "none",
                      }}
                    >
                      <i className="fas fa-arrow-left me-1"></i> Back to Login
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            padding: "0.65rem 1.5rem",
            fontSize: "0.78rem",
            color: "rgba(255,255,255,0.5)",
          }}
        >
          &copy; Copyright 2022 Akasa Air. Designed by{" "}
          <a
            href="https://www.plexitech.com/"
            style={{
              color: "#e94560",
              fontWeight: 600,
              textDecoration: "none",
            }}
          >
            PlexiTech Transsolutions LLP
          </a>
        </div>
      </div>
    );
  }
}
